import React from "react";
import "./CategoryTabs.css";

export interface CategoryTab {
  label: string;
  slug: string;
}

interface CategoryTabsProps {
  categories: CategoryTab[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  activeSlug,
  onSelect,
}) => {
  const tabs: CategoryTab[] = categories;

  return (
    <div className="category-tabs">
      {tabs.map(({ label, slug }, index) => {
        const isActive = slug === activeSlug;
        return (
          <button
            key={slug}
            type="button"
            className={`category-tab${isActive ? " category-tab--active" : ""}`}
            onClick={() => onSelect(slug)}
          >
            <span className="category-tab__border category-tab__border--top" />
            <span className="category-tab__border category-tab__border--bottom" />
            {index === 0 && (
              <span className="category-tab__border category-tab__border--left" />
            )}
            <span className="category-tab__border category-tab__border--right" />
            <span className="category-tab__label">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryTabs;
